import React, { useEffect, useState } from 'react';
import { animate, motion, useReducedMotion } from 'framer-motion';
interface ScoreGaugeProps {
  score: number;
  /** Tailwind stroke-* class for the progress arc. */
  strokeClass: string;
}
const SIZE = 184;
const STROKE = 10;
const RADIUS = (SIZE - STROKE) / 2;
const EASE = [0.23, 1, 0.32, 1] as const;

/** Circular toxicity gauge with a quick count-up on first render. */
export function ScoreGauge({
  score,
  strokeClass
}: ScoreGaugeProps) {
  const reduceMotion = useReducedMotion();
  const clamped = Math.max(0, Math.min(100, Math.round(score)));
  const [display, setDisplay] = useState(reduceMotion ? clamped : 0);
  useEffect(() => {
    if (reduceMotion) {
      setDisplay(clamped);
      return;
    }
    const controls = animate(0, clamped, {
      duration: 0.3,
      delay: 0.1,
      ease: EASE,
      onUpdate: value => setDisplay(Math.round(value))
    });
    return () => controls.stop();
  }, [clamped, reduceMotion]);
  return <div className="relative h-[168px] w-[168px] sm:h-[184px] sm:w-[184px]" role="img" aria-label={`Toxicity score ${clamped} out of 100`} data-id="element-418" data-mp="1kavxql4m9wdq">
      <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className="h-full w-full -rotate-90" aria-hidden="true" data-id="element-419" data-mp="1fddosuqlnh5q">
        <circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" strokeWidth={STROKE} className="stroke-white/[0.06]" data-id="element-420" data-mp="1tcvfjfngh4hq" />
        <motion.circle cx={SIZE / 2} cy={SIZE / 2} r={RADIUS} fill="none" strokeWidth={STROKE} strokeLinecap="round" className={strokeClass} initial={reduceMotion ? false : {
        pathLength: 0
      }} animate={{
        pathLength: Math.max(clamped / 100, 0.001)
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: EASE
      }} data-id="element-421" data-mp="2386vg1alohr2" />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center" aria-hidden="true" data-id="element-422" data-mp="2ly54okq4wgwa">
        <span className="text-[56px] font-semibold leading-none tracking-tight text-white tabular-nums sm:text-[64px]" data-id="element-423" data-mp="2gzbnah7q85qu">
          {display}
        </span>
        <span className="mt-1 text-xs text-forensic-subtle" data-id="element-424" data-mp="1iqdezqtqqyri">out of 100</span>
      </div>
    </div>;
}